export const isMobileIOS = () => {
  const isIOSPlatform = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
    navigator.platform,
  );
  const isIOSUserAgent = /iPhone|iPad|iPod/.test(navigator.userAgent);
  return isIOSPlatform || isIOSUserAgent;
};

export const isIOS = () => {
  return isMobileIOS() || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
};
